// import React from 'react';

// const BusRatesTable = () => {
//   const ratesData = [
    
//     { seater: "SWIFT DESIRE", mumbai: "4+1", mahabaleshwar: "12", specialPermitNumber: "919930929439", driver: "Extra", parking: "Extra" },
//     { seater: "AURA", mumbai: "4+1", mahabaleshwar: "12", specialPermitNumber: "919930929439", driver: "Extra", parking: "Extra" },
//     { seater: "TOYOTA ETIOS", mumbai: "4+1", mahabaleshwar: "14", specialPermitNumber: "919930929439", driver: "Extra", parking: "Extra" },
//     { seater: "ERITGA", mumbai: "6+1", mahabaleshwar: "15", specialPermitNumber: "919930929439", driver: "Extra", parking: "Extra" },
//     { seater: "INNOVA", mumbai: "6+1", mahabaleshwar: "18", specialPermitNumber: "919930929439", driver: "Extra", parking: "Extra" },
//     { seater: "SCORPIO", mumbai: "8+1", mahabaleshwar: "18", specialPermitNumber: "919930929439", driver: "Extra", parking: "Extra" },
//     { seater: "INNOVA CRYSTA", mumbai: "6+1", mahabaleshwar: "20", specialPermitNumber: "919930929439", driver: "Extra", parking: "Extra" },
//     { seater: "AUDI", mumbai: "4+1", mahabaleshwar: "ON CALL", specialPermitNumber: "919930929439", driver: "Extra", parking: "Extra" },
//     { seater: "TEMPO TRAVELLER", mumbai: "13/17 SEATER", mahabaleshwar: "ON CALL", specialPermitNumber: "919930929439", driver: "Extra", parking: "Extra" },
//     { seater: "MINI BUS", mumbai: "20 SEATER", mahabaleshwar: "ON CALL", specialPermitNumber: "919930929439", driver: "Extra", parking: "Extra" },
//     { seater: "BUS", mumbai: "32-52", mahabaleshwar: "ON CALL", specialPermitNumber: "919930929439", driver: "Extra", parking: "Extra" },
//     { seater: "TAVERA", mumbai: "8+1", mahabaleshwar: "18", specialPermitNumber: "919930929439", driver: "Extra", parking: "Extra" },
//     { seater: "KIA Carens", mumbai: "6+1/7+1", mahabaleshwar: "17/KM & 18/KM", specialPermitNumber: "919930929439", driver: "Extra", parking: "Extra" },
//   ];

//   const tableStyle = {
//     width: "100%",
//     borderCollapse: "collapse",
//     margin: "20px auto",
//   };

//   const thStyle = {
//     backgroundColor: "#C92227",
//     color: "white",
//     padding: "8px",
//     border: "1px solid #ddd",
//   };

//   const tdStyle = {
//     padding: "8px",
//     border: "1px solid #ddd",
//     textAlign: "center",
//   };

//   const trEvenStyle = {
//     backgroundColor: "#f2f2f2",
//   };

//   const handleWhatsAppClick = (number, seater) => {
//     console.log(`Opening WhatsApp for ${seater} with number ${number}`);
//     const message = `Hi, I would like to inquire about the rates for the ${seater}.`;
//     const url = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
//     window.open(url, '_blank');
//   };

//   return (
//     <div className="container p-0">
//       {/* <h3>Rates for AC Buses</h3> */}
//       <div className="table-responsive">
//         <table style={tableStyle}>
//           <thead>
//             <tr>
//               <th style={thStyle}>Bus Name</th>
//               <th style={thStyle}>Seater</th>
//               <th style={thStyle}>Per KM</th>
//               <th style={thStyle}>Driver Food</th>
//               <th style={thStyle}>Toll Parking</th>
//               <th style={thStyle}>Book Now</th>
//             </tr>
//           </thead>
//           <tbody>
//             {ratesData.map((row, index) => (
//               <tr key={index} style={index % 2 === 0 ? trEvenStyle : null}>
//                 <td style={tdStyle}>{row.seater}</td>
//                 <td style={tdStyle}>{row.mumbai}</td>
//                 <td style={tdStyle}>{row.mahabaleshwar}</td>
//                 <td style={tdStyle}>{row.driver}</td>
//                 <td style={tdStyle}>{row.parking}</td>
//                 <td style={tdStyle}>
//                   <button
//                     onClick={() => handleWhatsAppClick(row.specialPermitNumber, row.seater)}
//                     style={{
//                       cursor: "pointer",
//                       backgroundColor: "#C92227",
//                       padding: "10px",
//                       borderRadius: "8px",
//                       color: "white",
//                     }}
//                   >
//                     Book Now
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>


//     </div>
//   );
// };

// export default BusRatesTable;



import React from "react";
import "./BusRatesTable.css";

const BusRatesTable = () => {
  const ratesData = [
    {
      seater: "SWIFT DESIRE",
      mumbai: "4+1",
      mahabaleshwar: "12",
      specialPermitNumber: "919930929439",
      driver: "Extra",
      parking: "Extra",
    },
    {
      seater: "AURA",
      mumbai: "4+1",
      mahabaleshwar: "12",
      specialPermitNumber: "919930929439",
      driver: "Extra",
      parking: "Extra",
    },
    {
      seater: "TOYOTA ETIOS",
      mumbai: "4+1",
      mahabaleshwar: "14",
      specialPermitNumber: "919930929439",
      driver: "Extra",
      parking: "Extra",
    },
    {
      seater: "ERITGA",
      mumbai: "6+1",
      mahabaleshwar: "15",
      specialPermitNumber: "919930929439",
      driver: "Extra",
      parking: "Extra",
    },
    {
      seater: "INNOVA",
      mumbai: "6+1",
      mahabaleshwar: "18",
      specialPermitNumber: "919930929439",
      driver: "Extra",
      parking: "Extra",
    },
    {
      seater: "SCORPIO",
      mumbai: "8+1",
      mahabaleshwar: "18",
      specialPermitNumber: "919930929439",
      driver: "Extra",
      parking: "Extra",
    },
    {
      seater: "INNOVA CRYSTA",
      mumbai: "6+1",
      mahabaleshwar: "20",
      specialPermitNumber: "919930929439",
      driver: "Extra",
      parking: "Extra",
    },
    {
      seater: "AUDI",
      mumbai: "4+1",
      mahabaleshwar: "ON CALL",
      specialPermitNumber: "919930929439",
      driver: "Extra",
      parking: "Extra",
    },
    {
      seater: "TEMPO TRAVELLER",
      mumbai: "13/17 SEATER",
      mahabaleshwar: "ON CALL",
      specialPermitNumber: "919930929439",
      driver: "Extra",
      parking: "Extra",
    },
    {
      seater: "MINI BUS",
      mumbai: "20 SEATER",
      mahabaleshwar: "ON CALL",
      specialPermitNumber: "919930929439",
      driver: "Extra",
      parking: "Extra",
    },
    {
      seater: "BUS",
      mumbai: "32-52",
      mahabaleshwar: "ON CALL",
      specialPermitNumber: "919930929439",
      driver: "Extra",
      parking: "Extra",
    },
    {
      seater: "TAVERA",
      mumbai: "8+1",
      mahabaleshwar: "18",
      specialPermitNumber: "919930929439",
      driver: "Extra",
      parking: "Extra",
    },
    {
      seater: "KIA Carens",
      mumbai: "6+1/7+1",
      mahabaleshwar: "17/KM & 18/KM",
      specialPermitNumber: "919930929439",
      driver: "Extra",
      parking: "Extra",
    },
  ];

  const handleWhatsAppClick = (number, vehicle) => {
    const message = `Hi, I would like to inquire about the rates for the ${vehicle}.`;

    const url = `https://wa.me/${number}?text=${encodeURIComponent(
      message
    )}`;

    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="brt-section">
      <div className="brt-container">

        <div className="brt-heading">
          <span className="brt-heading-line"></span>
          <div>
            <p className="brt-eyebrow">TRAVEL &amp; TRANSPORT</p>
            <h2>Bus &amp; Car Rental Rates</h2>
            <p className="brt-subtitle">
              Choose your preferred vehicle and contact us instantly for
              booking and rate details.
            </p>
          </div>
          <span className="brt-heading-line"></span>
        </div>

        <div className="brt-card">
          <div className="brt-table-wrapper">
            <table className="brt-table">
              <thead>
                <tr>
                  <th>Bus Name</th>
                  <th>Seater</th>
                  <th>Per KM</th>
                  <th>Driver Food</th>
                  <th>Toll Parking</th>
                  <th>Book Now</th>
                </tr>
              </thead>

              <tbody>
                {ratesData.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <div className="brt-vehicle">
                        <span className="brt-vehicle-icon">🚘</span>
                        <span>{row.seater}</span>
                      </div>
                    </td>

                    <td>
                      <span className="brt-seat-badge">
                        {row.mumbai}
                      </span>
                    </td>

                    <td>
                      <span
                        className={
                          row.mahabaleshwar === "ON CALL"
                            ? "brt-price brt-on-call"
                            : "brt-price"
                        }
                      >
                        {row.mahabaleshwar}
                      </span>
                    </td>

                    <td>
                      <span className="brt-extra">
                        {row.driver}
                      </span>
                    </td>

                    <td>
                      <span className="brt-extra">
                        {row.parking}
                      </span>
                    </td>

                    <td>
                      <button
                        type="button"
                        className="brt-book-btn"
                        onClick={() =>
                          handleWhatsAppClick(
                            row.specialPermitNumber,
                            row.seater
                          )
                        }
                      >
                        <span className="brt-whatsapp-icon">☏</span>
                        Book Now
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="brt-footer">
            <div className="brt-footer-dot"></div>
            <p>
              <strong>Need a customized package?</strong>{" "}
              Contact us for special rates and group bookings.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusRatesTable;
